import authType from '~/shared/utils/auth/authType';
import useHandleAuth0Authenticate from './useHandleAuth0Authenticate';
import useHandleCognitoAuthenticate from './useHandleCognitoAuthenticate';
import useHandleTelegramAuthenticate from './useHandleTelegramAuthenticate';

const useHandleAuthenticate = () => {
  const { handleTelegramAuthenticate, loading: loadingTelegram } =
    useHandleTelegramAuthenticate();
  const { handleAuth0Authenticate, loading: loadingAuth0 } =
    useHandleAuth0Authenticate();
  const { handleCognitoAuthenticate, loading: loadingCognito } =
    useHandleCognitoAuthenticate();
  const loading = loadingTelegram || loadingAuth0 || loadingCognito;
  const handleAuthenticate = async (
    variables: AuthVariables,
    accessToken: string,
  ) => {
    const currentAuthType = authType.get();
    if (currentAuthType === 'telegram') {
      return handleTelegramAuthenticate(variables, accessToken);
    }
    if (currentAuthType === 'cognito') {
      return handleCognitoAuthenticate(variables, accessToken);
    }
    return handleAuth0Authenticate(variables, accessToken);
  };
  return {
    handleAuthenticate,
    loading,
  };
};

export default useHandleAuthenticate;
